import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IDropshippingRequestProductSchemaPartial } from '../../type/dropshippingRequestProduct';

export interface IAllowDropshippingProductRequestsMutationFields {
  _ids: string[];
}


export interface IAllowDropshippingProductRequestsMutationResponseFields {
  updatedDropshippingProductRequests: IDropshippingRequestProductSchemaPartial[];
}


export function allowDropshippingProductRequestsMutation(fragment: string): DocumentNode {
  return gql`
        mutation allowDropshippingProductRequests (
        $_ids: [String]!
        ) {
        allowDropshippingProductRequests (
        _ids: $_ids
        ) {
        ...fragment
        }
        }
        fragment fragment on AllowDropshippingProductRequestsMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useAllowDropshippingProductRequestsMutation<TData extends Partial<IAllowDropshippingProductRequestsMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ allowDropshippingProductRequests: TData },
        IAllowDropshippingProductRequestsMutationFields>,
) {
  return useMutation<{ allowDropshippingProductRequests: TData },
      IAllowDropshippingProductRequestsMutationFields>(
        allowDropshippingProductRequestsMutation(fragment), options,
      );
}
